module.exports = __webpack_public_path__ + "img/gamesdk11.a17e89d.png";